import api from '../../plugins/api'

/* eslint-disable no-unused-vars */

export default {
  namespaced: true,
  state: {
    filterParams: {},
    items: [],
    count: 0,
  },
  actions: {
    async fetchItems({commit, state}, params = {}) {
      const filterParams = {...state.filterParams, ...params}
      const items = await api.EnrollForm.findForAssignClass({...filterParams})
      commit('changeState', {filterParams, items})
    },
    async countItems({commit, state}, params = {}) {
      const {_sort, populates, ...filterParams} = {...state.filterParams, ...params}
      const count = await api.EnrollForm.countForAssignClass({...filterParams})
      commit('changeState', {count})
    },
    exportExcel({state}, options = {}) {
      const filterParams = {...state.filterParams, ...options}
      return api.EnrollForm.exportAssignClass(filterParams)
    },
    fetchClassesIndependent(_, options = {}) {
      return api.EnrollClasses.fetch(options)
    },
    updateAssignClass(_, {id, ...params}) {
      return api.EnrollForm.updateAssignClass(id, params)
    },
    updateDocumentStates(_, {id, ...params}) {
      return api.EnrollForm.updateDocumentStates(id, params)
    },
    withdrawDocument(_id, {id}) {
      return api.EnrollForm.withdrawDocument(id, {})
    },
    displaceAssignedClass(_id, {id}) {
      return api.EnrollForm.displaceAssignedClass(id, {})
    },
  },
  getters: {
    items: state => state.items,
    count: state => state.count,
    filterParams: state => state.filterParams,
  },
}
